module.exports = __webpack_public_path__ + "static/18-1b308dceef3380d9d0ebf47175ee9e54.gif";